import { render, staticRenderFns } from "./SalesRecapRelated.vue?vue&type=template&id=3ab8d550&"
import script from "./SalesRecapRelated.vue?vue&type=script&lang=js&"
export * from "./SalesRecapRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports